import update from 'immutability-helper';

import { ConfigurationCode } from '../../../interfaces/ConfigurationCode';
import Store from '../../../interfaces/Store';

export const setConfigurationCodeReducer = (
  state: Store,
  configurationCode: ConfigurationCode,
): Store => {
  return update(state, {
    configuration: {
      configurationCode: { $set: configurationCode },
    },
  });
};
